import getCookie from './getCookie';

export const XSRF_COOKIE_NAME = 'XSRF-TOKEN';
export const XSRF_TOKEN_HEADER = 'X-XSRF-TOKEN';
const API_BASE_PATH = process.env.NODE_ENV === 'development' ? '/api' : '/my-benefits';

const customizedFetch = (resource, init = {}) => {
  const customHeaders = init.headers || {};

  return fetch(`${API_BASE_PATH}/${resource}`, {
    ...init,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      [XSRF_TOKEN_HEADER]: getCookie(XSRF_COOKIE_NAME),
      ...customHeaders,
    },
  });
};

export default customizedFetch;
